import CircularProgress from './CircularProgress.component';
import { CIRCULAR_PROGRESS_SIZE } from '../constants';

CircularProgress.SIZE = CIRCULAR_PROGRESS_SIZE;
export default CircularProgress;
